class BackInStock extends HTMLElement {
  constructor () {
    super()

    this.els = {
      modalTrigger: this.querySelector('[data-back-in-stock-el="trigger"]'),
      modal: this.querySelector('[data-back-in-stock-el="modal"]'),
      backDrop: this.querySelector('[data-back-in-stock-el="backDrop"]'),
      modalClose: this.querySelector('[data-back-in-stock-el="modalClose"]'),
      submit: this.querySelector('[data-back-in-stock-el="submit"]'),
      email: this.querySelector('[data-back-in-stock-el="email"]'),
      select: this.querySelector('[data-back-in-stock-el="select"]'),
      price: this.querySelector('[data-back-in-stock-el="price"] .mon-Money'),
      success: this.querySelector('[data-back-in-stock-el="success"]'),
      error: this.querySelector('[data-back-in-stock-el="error"]'),
    }

    this.messages = {
      email: this.querySelector('[data-translations="email"]').innerText,
      success: this.querySelector('[data-translations="success"]').innerText,
      error: this.querySelector('[data-translations="error"]').innerText,
    }

    this.isOpen = false

    this.swat = null

    this.productId = this.dataset.productId
    this.variantId = this.dataset.variantId
    this.url = this.dataset.url
    this.imageUrl = this.dataset.url
    this.variantPrice = this.dataset.variantPrice
  }

  connectedCallback () {
    this.setupListeners()
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(this.onSwymLoadCallback.bind(this))
  }

  setupListeners () {
    if (this.els.modalTrigger) {
      this.els.modalTrigger.addEventListener('click', evt => {
        evt.preventDefault()
        this.showModal()
      })
    }

    if (this.els.modalClose) {
      this.els.modalClose.addEventListener('click', evt => {
        evt.preventDefault()
        this.hideModal()
      })
    }

    if (this.els.backDrop) {
      this.els.backDrop.addEventListener('click', evt => {
        evt.preventDefault()
        this.hideModal()
      })
    }

    if (this.els.submit) {
      this.els.submit.addEventListener('click', evt => {
        evt.preventDefault()
        this.onSubmit()
      })
    }

    if (this.els.select) {
      this.els.select.addEventListener('change', evt => {
        this.variantId = this.els.select.value
        this.clear()
      })
    }

    if (this.els.email) {
      this.els.email.addEventListener('input', evt => {
        this.hideEmailValidation()
      })
    }

    document.addEventListener('keyup', evt => {
      if (evt.key === 'Escape' && this.isOpen) {
        this.clear()
        this.hideModal()
      }
    })
  }

  onSwymLoadCallback (swat) {
    if (swat) {
      this.swat = swat
    }
  }

  showModal () {
    if (this.els.modal) {
      this.els.modal.removeAttribute('aria-hidden')
      this.els.email.focus()
      this.isOpen = true
      document.body.classList.add('lyt-ModalOpen')
    }
  }

  hideModal () {
    if (this.els.modal) {
      this.els.modal.setAttribute('aria-hidden', true)
      this.isOpen = false
      document.body.classList.remove('lyt-ModalOpen')
    }
  }

  get price () {
    const priceEl = this.els.price

    if (priceEl) {
      return priceEl.innerText
    }

    return this.variantPrice
  }

  get email () {
    return this.els.email.value
  }

  isValidEmail (email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  showEmailValidation () {
    this.showErrorMessage(this.messages.email)
  }

  hideEmailValidation () {
    this.hideErrorMessage()
  }

  showSuccessMessage (message) {
    this.els.success.innerText = message
    this.els.success.removeAttribute('aria-hidden')
  }

  hideSuccessMessage () {
    this.els.success.setAttribute('aria-hidden', true)
  }

  showErrorMessage (message) {
    this.els.error.innerText = message
    this.els.error.removeAttribute('aria-hidden')
  }

  hideErrorMessage () {
    this.els.error.innerText = ''
    this.els.error.setAttribute('aria-hidden', true)
  }

  clear () {
    this.hideEmailValidation()
    this.hideSuccessMessage()
    this.hideErrorMessage()
  }

  onSubmit () {
    this.clear()

    if (!this.swat) {
      return
    }

    if (!this.isValidEmail(this.email)) {
      this.showEmailValidation()
      return
    }

    const mediumValue = this.email
    const medium = 'email'
    const topic = 'backinstock'

    const product = {
      epi: this.variantId,
      empi: this.productId,
      du: this.url,
      iu: this.imageUrl,
      pr: this.price,
    }

    const onSuccess = response => {
      const message = this.messages.success || response.message
      this.showSuccessMessage(message)
    }

    const onError = error => {
      const message = this.messages.error || error.message
      this.showErrorMessage(message)
    }

    try {
      this.swat.subscribeForProductAlert(mediumValue, medium, product, onSuccess, onError, 0, topic)
    } catch (err) {
      this.showErrorMessage(this.messages.error)
    }
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
